module.exports = __webpack_public_path__ + "img/4.609f5fa0.jpeg";